import React from 'react';
import {Chip, Tooltip} from '@mui/material';

/**
 * CONFLICT badge. Clickable (navigates to the Conflicts tab) only when a single
 * conflict anchor is unambiguous — multi-AR questions show a non-clickable badge
 * at question level; their per-AR badges are the clickable ones.
 */
export default function ConflictBadge({clickable = false, onClick, tooltip}) {
    const chip = (
        <Chip
            label="CONFLICT"
            size="small"
            color="error"
            variant="outlined"
            onClick={clickable ? (e) => {
                e.stopPropagation();
                onClick?.();
            } : undefined}
            sx={{
                height: 20,
                fontSize: '0.65rem',
                fontWeight: 700,
                cursor: clickable ? 'pointer' : 'default',
            }}
        />
    );
    if (!tooltip) {
        return chip;
    }
    return <Tooltip title={tooltip} arrow>{chip}</Tooltip>;
}
